import { StateCreator, create } from 'zustand';

import { IGlobalFilterData } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';

export type TagsValue = {
    name: string;
    isExclude: boolean;
};

export type Tag = ISelectOption<TagsValue>;

interface Props {
    globalFilterData?: IGlobalFilterData;
    toggleGlobalFilterComponent: boolean;
    getValueFromStore: <T>(key: string) => T | undefined;
    setToggleGlobalFilterComponent: (value: boolean) => void;
    update: (key: string, value: string | null) => void;
    updateReplace: (value: any) => void;
    updateBatch: (value: any) => void;
    defaultValues: { [key: string]: any };
    setDefaultValues: (value: { [key: string]: any }) => void;
    reset: () => void;
}

const state: StateCreator<Props> = (set, get) => ({
    toggleGlobalFilterComponent: false,
    globalFilterData: undefined,
    getValueFromStore: (key) => {
        const { globalFilterData } = get();
        return globalFilterData?.[key];
    },
    update: (key, value) => {
        const { globalFilterData } = get();
        const newValue = {
            ...globalFilterData,
            [key]: value,
        };
        set({ globalFilterData: newValue });
    },
    updateBatch: (value) => {
        const { globalFilterData } = get();
        set({ globalFilterData: { ...globalFilterData, ...value } });
    },
    updateReplace: (value) => {
        set({ globalFilterData: { ...value } });
    },
    setToggleGlobalFilterComponent: (value) => set({ toggleGlobalFilterComponent: value }),
    defaultValues: {},
    setDefaultValues: (value) => set({ defaultValues: value }),
    reset: () => set({ globalFilterData: undefined, defaultValues: {}, toggleGlobalFilterComponent: false }),
});

export const useGlobalFilterDataStore = create(state);
